export interface ITicketInterventionReport {
  fk_appointment?: number
  reserve?: string
  start_date?: any
  end_date?: any
  signature?: string
  number_km?: number
  share_email?:any
}

export class TicketInterventionReport {
  /**
   *
   */
  fk_appointment?: number
  reserve?: string
  start_date?: any
  end_date?: any
  signature?: string
  number_km?: number
  share_email?:any

  constructor(startDate: string, endDate: string) {
    this.fk_appointment = null;
    this.reserve = "";
    this.start_date = startDate;
    this.end_date = endDate;
    this.signature = null;
    this.number_km = null,
    this.share_email = null
  }
}


// WEBPACK FOOTER //
// ./src/models/ticket/ticket-intervention-report.model.ts